import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const session_id = params.get('session_id');
    if (!session_id) { navigate('/login'); return; }
    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id });
        setUser(data.user);
        navigate('/dashboard', { state: { user: data.user } });
      } catch {
        navigate('/login');
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-royal font-serif text-xl">Signing you in…</div>
    </div>
  );
}
